import { DateTime } from 'luxon';
import { TimeSlot } from '@model';
import { isTimeSlot } from './type-guards';

export interface ParsedTimeSlotDates {
  slot: TimeSlot;
  fromDate: string;
  toDate: string;
}

export function parseProductTimeSlot(time: unknown): ParsedTimeSlotDates | null {
  if (!time || typeof time !== 'object' || !('slot' in time) || !isTimeSlot((time as { slot: unknown }).slot)) {
    return null;
  }

  const slot = (time as { slot: TimeSlot }).slot;

  if (!slot.guestFacingFrom || !slot.guestFacingTo) {
    return null;
  }

  return {
    slot,
    fromDate: DateTime.fromISO(slot.guestFacingFrom).toLocalDateTime(),
    toDate: DateTime.fromISO(slot.guestFacingTo).toLocalDateTime(),
  };
}
